import React from 'react'
import { useAppConfigContext } from 'src/viewLayer/components/contexts/AppConfigContext'
// Hooks
import usePerformanceTracker from 'src/viewLayer/components/hooks/usePerformanceTracker'
import BusinessErrorPage from 'src/viewLayer/components/pages/BusinessErrorPage'
import Footer from 'src/viewLayer/components/pages/CardLayout/Footer'

import { FooterContainer } from './index.styled'
// Components
import NavBar from './NavBar'

const WebBusinessErrorPage = ({ appType }) => (
  <>
    <NavBar />
    <BusinessErrorPage appType={appType} />
    <FooterContainer>
      <Footer color="transparent" />
    </FooterContainer>
  </>
)

const NativeMobileBusinessErrorPage = ({ appType }) => <BusinessErrorPage appType={appType} />

export default function BusinessErrorPages(properties) {
  usePerformanceTracker()
  const { devicePath } = useAppConfigContext()

  return devicePath === 'login' ? (
    <WebBusinessErrorPage {...properties} />
  ) : (
    <NativeMobileBusinessErrorPage {...properties} />
  )
}
